'use client';

import Button from '@enlighten/design-system/dist/Button';
import Dialog from '@enlighten/design-system/dist/Dialog';
import Grid from '@enlighten/design-system/dist/Grid';
import Close from '@mui/icons-material/Close';
import Image from 'next/image';
import type { VideoHTMLAttributes } from 'react';
import { useState } from 'react';

import PlayButtonImage from '@/assets/images/play_button.png';

export interface VideoDialogProps extends VideoHTMLAttributes<HTMLVideoElement> {
	source: string;
}

export default function VideoDialog({ source, ...props }: VideoDialogProps) {
	const [open, setOpen] = useState<boolean>(false);

	return (
		<>
			<Button
				variant="text"
				onClick={() => {
					setOpen(true);
				}}
				sx={{
					width: { xs: 50, md: 64 },
					height: { xs: 50, md: 64 },
					aspectRatio: '1 / 1',
					padding: 0,
					'& img': {
						width: { xs: 50, md: '100%' },
						height: 'auto',
					},
				}}
			>
				<Image src={PlayButtonImage} alt="play" />
			</Button>
			<Dialog
				open={open}
				onClose={(_, reason) => {
					if (reason === 'backdropClick') {
						setOpen(false);
					}
				}}
				slotProps={{
					paper: {
						sx: {
							bgcolor: 'transparent',
							maxWidth: { xs: '100%', md: 937 },
							width: '100%',
							height: { xs: 'auto', md: 580 },
							borderRadius: 0,
							boxShadow: 'none',
						},
					},
				}}
				sx={{
					'& iframe': {
						border: 'none',
					},
				}}
			>
				<Grid container justifyContent="flex-end" alignItems="center">
					<Button
						title="close"
						disableRipple
						variant="text"
						onClick={() => {
							setOpen(false);
						}}
						sx={{
							padding: '2px 0 2px 2px',
							':hover': {
								bgcolor: 'transparent',
							},
						}}
					>
						<Close fontSize="medium" sx={{ color: 'common.white' }} />
					</Button>
				</Grid>
				<video title="video" {...props}>
					<source src={source} type="video/mp4" />
				</video>
			</Dialog>
		</>
	);
}
